<template>
        <el-container style="height: 100%;">
            <el-header class="app-title">
            <img src="@/assets/images/logo.jpeg" style="float: left;">
            </el-header>
              <el-container>
              <el-main style="overflow: inherit;" class="top-main-div">
                    <div :class="{'background-white': $route.path !='/login'}">
                      <div class="app-inner">
                        <keep-alive>
                          <router-view v-if="$route.meta.keepAlive "></router-view>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive "></router-view>
                      </div>
                    </div>
                  </el-main>
            </el-container>
        </el-container>
</template>

<script>

import '@/assets/css/base.less'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({

    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  .background-white{
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/AppUnLogin.vue